import AddonHeader from '@features/settings/pages/billing/components/usage/addon-header';
import { Crown1, Money, Timer, TimerPause, TimerStart } from 'iconsax-react';
import AddonItem from '@features/settings/pages/billing/components/usage/addon-item';
import { formatDate } from '@shared/utils/helpers/format-date';
import { useGetSubscription } from '@shared/services/get-subscription';
import Loader from '@shared/components/reusables/loader';
import { Text } from '@src/design-system/text';

const Usage = () => {
  const { data: subscription, isFetching } = useGetSubscription();

  if (!subscription?.id) return null;
  if (isFetching) return <Loader height='50h' />;

  return (
    <>
      {subscription ? (
        <div className='w-full border border-primary-200 rounded-xl'>
          <div className='flex'>
            <AddonHeader
              icon={Crown1}
              subTitle='Subscription'
              title={subscription.plan.name}
            />
            <AddonHeader
              icon={Money}
              subTitle='Pricing'
              title={
                subscription.plan_price
                  ? `${subscription.plan_price.amount_currency} ${subscription.plan_price.amount} Yearly`
                  : 'Free Trial'
              }
            />
            <AddonHeader
              icon={TimerStart}
              subTitle='Start Date'
              title={formatDate(subscription.current_period_start)}
            />
            <AddonHeader
              icon={TimerPause}
              subTitle='Next Bill on'
              title={formatDate(subscription.current_period_end)}
            />
            <AddonHeader
              icon={Timer}
              subTitle='End Date'
              className='border-r-0'
              title={formatDate(subscription.current_period_end)}
            />
          </div>
          <div className='p-4 grid lg:grid-cols-4 sm:grid-cols-12 md:grid-cols-2 gap-4'>
            {subscription.usages.map((usage) => (
              <AddonItem
                key={usage.id}
                name={usage.feature.feature.name}
                count={usage.usage_count}
                totalCount={usage.feature.quota}
              />
            ))}
          </div>
        </div>
      ) : (
        <>
          <Text className='text-center'>Subscribe now!</Text>
        </>
      )}
    </>
  );
};

export default Usage;
